<!--
 * @Author: Dzy
 * @Date: 2023-02-15 12:47:48
 * @LastEditors: Dzy
 * @LastEditTime: 2023-02-15 15:18:17
 * @Description: 列表数据查询项组件
-->
<template>
  <a-layout-header>
    <div class="tableSearch">
      <slot name="tableSearch"></slot>
    </div>
    <a-divider v-if="slots.tableButtons" style="border-color: #edeff2; margin: 10px 0 0" dashed />
    <a-row align="middle">
      <a-col v-if="tableName">
        <div class="tableIcon" />
      </a-col>
      <a-col v-if="tableName">
        <span class="tableName">{{ tableName }}</span>
      </a-col>
      <a-col>
        <slot name="tableButtons"> </slot>
      </a-col>
    </a-row>
  </a-layout-header>
</template>
<script setup>
import { useSlots, onMounted, onBeforeUnmount, onActivated, onDeactivated } from 'vue'
const slots = useSlots()

const props = defineProps({
  tableName: String
})

const emits = defineEmits(['search'])

const handleSearchEnter = (e) => {
  const key = e.keyCode

  if (key == 13) {
    emits('search')
  }
}

onMounted(() => {
  document.addEventListener('keyup', handleSearchEnter)
})

onBeforeUnmount(() => {
  console.log('销毁')
  document.removeEventListener('keyup', handleSearchEnter)
})
// 被包含在 keep-alive 中创建的组件，会多出两个生命周期的钩子: activated 与 deactivated
onActivated(()=>{
  document.addEventListener('keyup', handleSearchEnter)
})

onDeactivated(()=>{
  console.log('隐藏')
  document.removeEventListener('keyup', handleSearchEnter)
})
</script>
<style lang="less" scoped>
.tableName {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 125% */
  letter-spacing: 0.8px;
  margin: 0 32px 0 8px;
}
.tableIcon {
  width: 4px;
  height: 14px;
  background: #3091f2;
}
</style>
